<template>
  <div style="min-height:400px">
    <div class="common-form" style="border-bottom: 1px solid #DCDFE6;">技师统计</div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="时间筛选:">
          <el-date-picker size="small" v-model="searchForm.datePicker" type="daterange" align="right" unlink-panels format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeDate" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <!-- 为 ECharts 准备一个定义了宽高的 DOM -->
    <div ref="chart" style="width: 100%;"></div>
  </div>

</template>

<script>
import StatisticsApi from "@/api/statistics.js";
import { formatDate } from "@/utils/DateTime.js";
import * as echarts from "echarts";
export default {
  name: "Chart",
  data() {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
    return {
      dataList: [],
      myChart: null,
      /*是否正在加载*/
      loading: true,
      /*类别*/
      activeName: "new",
      /*时间快捷选项*/
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchForm: {
        datePicker: [
          formatDate(startDate, "yyyy-MM-dd"),
          formatDate(endDate, "yyyy-MM-dd")
        ]
      }
    };
  },
  created() {
    // this.getData();
  },
  mounted() {
    this.myEcharts();
  },
  methods: {
    /*创建图表对象*/
    myEcharts() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(this.$refs.chart);
      /*获取列表*/
      this.getData();
    },
    /*选择时间*/
    changeDate() {
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      self.loading = true;
      StatisticsApi.getWaitertable(
        {
          search_time: self.searchForm.datePicker
        },
        true
      )
        .then(res => {
          self.dataList = res.data;
          self.loading = false;
          self.initChart();
        })
        .catch(error => {});
    },
    initChart() {
      // const myChart = echarts.init(this.$refs.chart);
      let names = ["新增技师", "认证技师"];
      let xAxis = this.dataList.days;
      let series1 = [];
      let series2 = [];
      this.dataList.data.forEach(item => {
        series1.push(item.add_num);
        series2.push(item.auth_num);
      });
      // 指定图表的配置项和数据
      const option = {
        backgroundColor: "rgb(43, 51, 59)",
        tooltip: {
          trigger: "axis"
        },
        legend: {
          icon: "rect",
          itemWidth: 14,
          itemHeight: 5,
          itemGap: 13,
          data: names,
          right: "4%",
          textStyle: {
            fontSize: 12,
            color: "#F1F1F3"
          }
        },
        xAxis: [
          {
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "pink"
              }
            },
            data: xAxis
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "数据",
            axisLine: {
              lineStyle: {
                color: "#fff"
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14
              }
            },
            splitLine: {
              lineStyle: {
                color: "#57617B"
              }
            }
          }
        ],
        series: [
          {
            name: names[0],
            type: "line",
            // smooth: true,
            symbol: "circle",
            symbolSize: 5,
            // showSymbol: false,
            lineStyle: {
              normal: {
                width: 2
              }
            },
            itemStyle: {
              normal: {
                color: "rgb(137,189,27)",
                borderColor: "rgba(137,189,2,0.27)",
                borderWidth: 10
              }
            },
            data: series1
          },
          {
            name: names[1],
            type: "line",
            // smooth: true,
            symbol: "circle",
            symbolSize: 5,
            // showSymbol: false,
            lineStyle: {
              normal: {
                width: 2
              }
            },
            itemStyle: {
              normal: {
                color: "rgb(219,50,51)",
                borderColor: "rgba(219,50,51,0.2)",
                borderWidth: 10
              }
            },
            data: series2
          }
        ]
      };

      var currentIndex = -1;
      // setInterval(function() {
      //   var dataLen = option.series[0].data.length;

      //   // 取消之前高亮的图形
      //   this.myChart.dispatchAction({
      //     type: "downplay",
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   });
      //   currentIndex = (currentIndex + 1) % dataLen;
      //   // 高亮当前图形
      //   this.myChart.dispatchAction({
      //     type: "highlight",
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   });
      //   // 显示 tooltip
      //   this.myChart.dispatchAction({
      //     type: "showTip",
      //     seriesIndex: 0,
      //     dataIndex: currentIndex
      //   });
      // }, 2000);
      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/statistics/technician/part/Transaction3333.vue